const GradeIcon = ({ color, className }) => (
  <svg
    height="20"
    id="grade"
    style={{ fill: color }}
    viewBox="0 0 10 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    class={`MuiSvgIcon-root ${className}`}
  >
    <path
      d="M17,10.43V3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3v7.43a.99.99,0,0,0,.49.86l4.18,2.51-.99,2.34-2.22.19a.5.5,0,0,0-.3.88l1.69,1.46-.51,2.18a.5.5,0,0,0,.75.54L12,20.23l1.91,1.15a.5.5,0,0,0,.75-.54l-.51-2.18,1.69-1.46a.5.5,0,0,0-.29-.88l-2.22-.19-.99-2.34,4.18-2.51A.962.962,0,0,0,17,10.43Zm-4,1.8-1,.6-1-.6V3h2Z"
      data-name="Tracé 5870"
      id="Tracé_5870"
      transform="translate(-7 -2)"
    />
  </svg>
);

export default GradeIcon;
